module.exports = __webpack_public_path__ + "img/home_a.dd21fc44.png";